'use strict';

/* global angular */
import AuthorizationInfo from '../../core/ace-authorization-info';

angular.module('atex.aceui.service').factory('AuthorizationService',
  ['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',
    function AuthorizationService ($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {

      let cachedUsername, request;

      const whenPermissionService = ApplicationConfigurationService.getServiceConfigurationFor ('PermissionService')
        .then(function (conf) {
          return atex.aceui.service.PermissionService (
            atex.aceui.ServiceUtils.calculateServiceUrl (conf, 'security/permission'),
            { customQ: atex.aceui.AngularUtils.applyingQ ($q, $rootScope) }
          );
        });
      
      const getAuthorizationInfo = () => {
        return AuthenticationService.callWithAuthentication (function ({ username, token }) {
          if (cachedUsername !== username) {
            cachedUsername = username;
            request = whenPermissionService.then(function (PermissionService) {
              return PermissionService.getAuthorizationInfo({ username, token })
                .then((authInfo) => {
                  return new AuthorizationInfo(authInfo);
                });
            });
          }
          return request;
        });
      };

      return {
        getAuthorizationInfo,

        /**
       * Determines if the logged in user has a certain permission for a given type within a set of security contexts.
       *
       * @param {string} permission - A string representing a permission in the ACE permission system, for instance 'Create'.
       * @param {string} type - A string representing a type in the ACE type system, for instance 'articleContent'
       * @param {string[]} securityContexts - Optional array of security contexts, for instance ['sc-1', 'sc-2'], If ommitted the
       *   function will determine if the logged in user has the certain permission for the type in ANY context the
       *   user has permissions in.
       *
       * @return Promise<boolean>
       */
        hasPermission: (permission, type, securityContexts) => {
          return getAuthorizationInfo ()
            .then ((checkIfUser) => {
              return checkIfUser.hasPermission (permission, type, securityContexts);
            });
        },
        hasSuperpowers: () => {
          return AuthenticationService.callWithAuthentication (({ username, token }) => {
            return whenPermissionService
              .then((PermissionService) => {
                return PermissionService.isSuperuser ({ username, token });
              });
          });
        }
      };
    }
  ]);
